var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseinline = function SvgPauseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.14331 13C7.14331 13.5523 6.6956 14 6.14331 14H4.7146C4.16232 14 3.7146 13.5523 3.7146 13V3C3.7146 2.44772 4.16231 2 4.7146 2H6.14331C6.6956 2 7.14331 2.44772 7.14331 3V13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.2859 13C12.2859 13.5523 11.8382 14 11.2859 14H9.85718C9.30489 14 8.85718 13.5523 8.85718 13V3C8.85718 2.44772 9.30489 2 9.85718 2H11.2859C11.8382 2 12.2859 2.44772 12.2859 3V13Z"
  })));
};
export default SvgPauseinline;